<template>
  <transition name="component-fade">
    <div class="modal-confirm">
      <div class="modal-confirm__backdrop" />
      <div 

      class="modal-confirm__dialog">
        <div class="modal-confirm__header">
          <p class="mb-0" :class="customClass" v-html="msg"></p>
          <button
            v-if="showCancelIcon"
            type="button"
            class="modal-user__close"
            @click="$emit('cancel')"
          >
            <font-awesome-icon :icon="['fal', 'times']" />
          </button>
        </div>

        <div class="modal-confirm__body">
          <slot></slot>
        </div>

        <div class="modal-confirm__footer text-center">
          <BtnLink
            v-if="showNoButton"
            @click.native="$emit('cancel')"
            :disabled="loading"
            :label="$t('general.no')"
          />

          <Btn
            @click.native="$emit('confirm')"
            :disabled="loading"
            :loading="loading"
            :label="myOkLabel"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'ModalConfirm',
  //props: ['msg', 'loading', 'customClass'],

  props: {
    msg: {},
    loading: {},
    customClass: {},
    showNoButton: {
      default: true,
      type: Boolean,
    },
    width: {
      default: 500,
      type: Number
    },
    okLabel: {
      type: String,
    },    
  },

  data() {
    return {
      showCancelIcon: false,

    };
  },

  methods: {},

  computed: {
    myOkLabel() {
    if( this.okLabel ) {
      return  this.okLabel;
    }
      return  this.$t('general.yes')
    },
    dlgWidth() {
      return ""
    }
  },
  mounted() {

  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.modal-confirm {
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  color: $dark-grey;
  &__backdrop {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
  }
  &__dialog {
    background-color: #ffffff;
    position: relative;
    width: 450px;
    margin: 150px auto;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    z-index: 2;
    // -webkit-transform: translate3d(0, 0, 0);
    @media screen and (max-width: 767px) {
      width: 90%;
      max-width: 450px;
    }
  }
  &__close {
    width: 30px;
    height: 30px;
  }
  &__header {
    padding: 20px 20px 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 20px;
    @media screen and (max-width: 480px) {
      font-size: 16px;
    }
  }
  &__body {
    padding: 10px 20px 10px;
    font-size: 16px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }
  &__footer {
    margin: 10px;
    margin-top: 0px;
    padding-top: 10px;
    border-top: 0px solid $light-grey;
  }
}

.component-fade-enter-active {
  transition: opacity 0.5s;
}

.component-fade-leave-active {
  transition: opacity 0.5s;
}

.component-fade-leave-to {
  opacity: 0;
}

.component-fade-enter {
  opacity: 0;
}

.component-fade-enter-to {
}
</style>
